export default __webpack_public_path__ + "static/pilot-Kelly-7d810e4d85284c6b49a94ac4610a25d9.png";